import React from 'react';
const AgentMessagesConfig = {
	settings: {
		layout: {
			config: {}
		}
	},
	routes: [
		{
			path: '/account-summary-report',
			component: React.lazy(() => import('./TemplateReports'))
		}
	]
};
export default AgentMessagesConfig;
